module.exports = __webpack_public_path__ + "img/39_21.5c6c9b71.png";